import { AngularEditorConfig } from '@kolkov/angular-editor';

export const RICHTEXT_EDITOR_CONFIG: AngularEditorConfig = {
  editable: true,
  spellcheck: true,
  height: '7rem',
  minHeight: '5rem',
  // placeholder: 'Enter text here...',
  translate: 'no',
  defaultParagraphSeparator: 'p',
  defaultFontName: 'Roboto',
  defaultFontSize: '2',
  fonts: [
    { class: 'arial', name: 'Arial' },
    { class: 'times-new-roman', name: 'Times New Roman' },
    { class: 'calibri', name: 'Calibri' },
    { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    { class: 'roboto', name: 'Roboto' },
  ],
  customClasses: [
    { name: 'redText', class: 'redText' },
    { name: 'titleText', class: 'titleText', tag: 'h1' },
  ],
  sanitize: false,
  toolbarPosition: 'bottom',
  toolbarHiddenButtons: [
    [ 'undo',
    'redo',
    // 'bold',
    // 'italic',
    'underline',
    'strikeThrough',
    'subscript',
    'superscript',
    'justifyLeft',
    'justifyCenter',
    'justifyRight',
    'justifyFull',
    'indent',
    'outdent',
    'insertUnorderedList',
    'insertOrderedList',
    'heading',
    'fontName'],
    [
       'fontSize',
    'textColor',
    'backgroundColor',
    'customClasses',
    'link',
    'unlink',
    'insertImage',
    'insertVideo',
    'insertHorizontalRule',
    'removeFormat',
    'toggleEditorMode'
    ],
  ],
};

export enum Roles {
  // system roles
  BreakInUser = 'BreakInUser',
  PowerUser = 'PowerUser',
  CostAnalytics = 'CostAnalytics',
  BreakInUserLimited = 'BreakInUserLimited',
  Management = 'Management',
  BreakInUserFull = 'BreakInUserFull',
  ReadOnly = 'ReadOnly',
  FrontendClient = 'FrontendClient',
  FinanceUser = 'FinanceUser',
  // scope roles
  PortfolioLeadershipTeam = 'PortfolioLeadershipTeam',
  AreaOwner = 'AreaOwner',
  CoreTeam = 'CoreTeam',
  InitiativeOwner = 'InitiativeOwner',
  ProjectTeam = 'ProjectTeam',
  ExecutionSupervisor = 'ExecutionSupervisor',
  LookbackSupervisor = 'LookbackSupervisor',
  PreExecutionSupervisor = 'PreExecutionSupervisor',
  Initiator = 'Initiator'
}

export enum ProjectType {
  MEJ = 'MEJ',
  CAPEX = 'CAPEX',
  NotAssigned = 'NotAssigned'
}